import { useMemo } from "react";

import { SupportSelect, SupportSelectOption } from "./SupportSelect";
import { supportTicketCategoryCreateOptions } from "./supportTicketCategoryOptions";

import type { FC } from "react";

import type { TicketCategory } from "@megaron/support-contracts";

type Props = {
  value: TicketCategory | null;
  onChange: (value: TicketCategory | null) => void;
  isDisabled?: boolean;
  label?: string;
  variant?: "bold" | "form";
};

export const SupportTicketCategorySelect: FC<Props> = ({
  value,
  onChange,
  isDisabled,
  label,
  variant,
}) => {
  const options = useMemo<SupportSelectOption<TicketCategory>[]>(
    () => [
      { value: null, label: "Brak kategorii" },
      ...supportTicketCategoryCreateOptions.map((option) => ({
        value: option.value,
        label: option.label,
      })),
    ],
    [],
  );

  return (
    <SupportSelect<TicketCategory>
      variant={variant}
      label={label}
      placeholder="Wybierz kategorię..."
      value={value}
      options={options}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};
